import './styles/ViewDocuments.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext, ExAppContext } from '../Context';
import { ViewDocuments_PageMap, ViewDocuments_UserMode, MemberUser_TypeMap, App_ViewModeMap } from '../assets/keyMap';
import { Fragment, useContext, useState, useRef, useEffect, ReactElement } from 'react';
import { useHistory } from 'react-router';
import { IonDateString, IonDateFormat } from '../components/IonDate';
import { Browser } from '@capacitor/browser';
import { FilePicker } from '@capawesome/capacitor-file-picker';
import { Camera } from '@capacitor/camera';
import { DebugLogger as dlog } from '../components/Logger';
import axios from 'axios';
import ScrollBar from '../components/ScrollBar';

//classes
import Document from '../exClasses/document';
import DocumentCategory from '../exClasses/documentCategory';
import CommitteeType from '../exClasses/committeeType';
import SelectionList from '../classes/selectionList';
import MemberType from '../exClasses/memberType';

//controllers
import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';

//handlers
import SwipeOverscrollHandler from '../handlers/SwipeOverscrollHandler';

//components
import SelectionChecker from '../components/SelectionChecker';
import Checker from '../components/Checker';
import DateTimePicker from '../components/DateTimePicker';
import ImagePreviewer from '../components/ImagePreviewer';

//mui icons
// import PanoramaIcon from '@mui/icons-material/Panorama';
// import CropFreeIcon from '@mui/icons-material/CropFree';
// import SquareIcon from '@mui/icons-material/Square'; --deprecated of unuse
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import UploadIcon from '@mui/icons-material/Upload';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';

//graphics
import PPKMLogo from '../../assets/images/logos/ppkmLogo.jpg';
import { GalleryPhoto } from '@capacitor/camera';
import MemberUser from '../classes/memberUser';
import { rootCertificates } from 'tls';

class DocumentMap {
    public fileName: string = '';
    public source: string = ''; //can be base64String or urlSource
    public label: string = '';
    public description: string = '';
    public poster: string = '';
    public viewableMemberTypeIDs: string[] = [];
    public viewableMemberUserTypes: string[] = [];
    public viewableCommitteeTypeIDs: string[] = [];
    public datetimeCreated: Date | null = null;
    public datetimeExpired: Date | null = null;
}

const nonstate = {
    fetchDocumentsBatchSize: 10,
    max_attachment_size: 5, //5MB
    controlledImgSize: 1080
}

interface Props {

}

const ViewDocuments: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [page, SetPage] = useState(ViewDocuments_PageMap.CATEGORY_SELECTION);
    const [shouldFastScrollBottom, SetShouldFastScrollBottom] = useState<boolean>(true);
    const [userMode, SetUserMode] = useState(ViewDocuments_UserMode.MEMBER);
    const [filter_documentCategory, SetFilter_documentCategory] = useState<DocumentCategory | null>(null);
    const [filter_searchString, SetFilter_searchString] = useState<string>('');
    const [viewableDocuments, SetViewableDocuments] = useState<Document[]>([] as Document[]);
    const [editingDocument, SetEditingDocument] = useState<Document>({} as Document);
    //states - upload documents
    const [newUploadDocuments, SetNewUploadDocuments] = useState<DocumentMap[]>([] as DocumentMap[]);
    const [memberTypeCheckList, SetMemberTypeCheckList] = useState<string[]>([] as string[]);
    const [memberTypeListChecks, SetMemberTypeListChecks] = useState<boolean[]>([] as boolean[]);
    const [memberUserTypeCheckList, SetMemberUserTypeCheckList] = useState<string[]>([] as string[]);
    const [memberUserTypeListChecks, SetMemberUserTypeListChecks] = useState<boolean[]>([] as boolean[]);
    const [committeeTypeCheckList, SetCommitteeTypeCheckList] = useState<string[]>([] as string[]);
    const [committeeTypeListChecks, SetCommitteeTypeListChecks] = useState<boolean[]>([] as boolean[]);
    const [attemptUploadDocument, SetAttemptUploadDocument] = useState<DocumentMap>({} as DocumentMap);
    const [attemptUploadDocumentLabel, SetAttemptUploadDocumentLabel] = useState<string>('');
    const [attemptUploadDocumentDescription, SetAttemptUploadDocumentDescription] = useState<string>('');
    const [attemptUploadDocumentPoster, SetAttemptUploadDocumentPoster] = useState<string>('');
    const [selectedVisibilityViewDocument, SetSelectedVisibilityViewDocument] = useState<DocumentMap>({} as DocumentMap);
    const [attemptUploadDocumentDateTimeCreated, SetAttemptUploadDocumentDateTimeCreated] = useState<Date>(new Date());
    const [attemptUploadDocumentShouldExpired, SetAttemptUploadDocumentShouldExpired] = useState<boolean>(false);
    const [attemptUploadDocumentDateTimeExpired, SetAttemptUploadDocumentDateTimeExpired] = useState<Date | null>(null);
    const [uploadDocumentCount, SetUploadDocumentCount] = useState(0);
    //references
    const viewDocumentsRef = useRef<any>(null);
    const pageRef = useRef<any>(null);
    const newUploadDocumentsRef = useRef<DocumentMap[]>([] as DocumentMap[]);
    const attemptUploadDocumentRef = useRef<DocumentMap>({} as DocumentMap);
    const uploadDocumentCountRef = useRef<number>(uploadDocumentCount);
    const shouldReplacePosterRef = useRef<boolean>(false);
    const filter_documentCategoryRef = useRef<DocumentCategory | null>(null);
    //refs - objs
    const pageScrollRef = useRef<any>(null);
    const canvasRef = useRef<HTMLCanvasElement>();
    const imageRef = useRef(new Image());
    const history = useHistory();
    //refs - vars
    const attemptUploadDocumentPosterRef = useRef<string>('');
    //controller
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('ViewDocumentsTest: ' + JSON.stringify(attemptUploadDocumentPoster));
    // }, [attemptUploadDocumentPoster]);

    //add scroll listener to pageRef
    useEffect(() => {
        InitializeSelectionList();
        const ScrollCheck = () => {
            if (pageRef.current != undefined && pageRef.current != null) {
                const maxScroll = pageRef.current.scrollHeight - pageRef.current.clientHeight;
                if (pageRef.current.scrollTop >= maxScroll / 2) {
                    SetShouldFastScrollBottom(false);
                }
                else
                    SetShouldFastScrollBottom(true);
            }
        };
        if (pageRef.current != null) {
            pageRef.current.addEventListener('scroll', ScrollCheck);
        }
        return (() => {
            if (pageRef.current != null && pageRef.current != undefined)
                pageRef.current.removeEventListener('scroll', ScrollCheck);
        });
    }, []);

    //watch for pagelocation upate userMode
    useEffect(() => {
        if (location.pathname.includes('/Member'))
            SetUserMode(ViewDocuments_UserMode.MEMBER);
        else if (location.pathname.includes('/Committee'))
            SetUserMode(ViewDocuments_UserMode.COMMITTEE);
        else if (location.pathname.includes('/Newsletter')) {
            filter_documentCategoryRef.current = GetNewsletterDocumentCategory();
            SetFilter_documentCategory(filter_documentCategoryRef.current);
            setTimeout(() => SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION), 250);
        }

        // const pathVars = location.pathname.split('/');
        // if (pathVars.length >= 4) {
        //     const autoSelectedEvent = GetOngoingEventByID(pathVars[3]);
        //     if (Object.keys(autoSelectedEvent).length > 0) {
        //         SetSelectedEvent(autoSelectedEvent);
        //         SetPage(ViewEventGallery_PageMap.GALLERY);
        //     }
        // }
    }, [location.pathname]);

    //watch for page change
    useEffect(() => {
        //reset 

        switch (page) {
            case ViewDocuments_PageMap.CATEGORY_SELECTION:
                appContext.SetHeaderBackAction(() => () => {
                    // userMode == ViewDocuments_UserMode.MEMBER ?
                    //     history.push('/Home')
                    //     :
                    //     history.push('/Profile'); --deprecated
                    history.push('/Home');
                });
                break;
            case ViewDocuments_PageMap.DOCUMENT_SELECTION:
                appContext.SetHeaderBackAction(() => () => OnBackToCategorySelectionClicked());
                //clear newUploadDocuments
                newUploadDocumentsRef.current = [] as DocumentMap[];
                SetNewUploadDocuments([...newUploadDocumentsRef.current]);
                break;
            case ViewDocuments_PageMap.DOCUMENT_SETUP:
                ResetDocumentSetupForm();
                break;
        }
    }, [page, userMode]);

    //watch for upload document count, upload document to server
    // useEffect(() => {
    //     if(documentCount)
    // }, [documentCount]);

    //watch for filter_documentCategory update fetch viewableDocumentsByDocumentCategory
    useEffect(() => {
        if (filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) {
            databaseInterfaceController.Queue('fetchViewableDocumentsByCategoryID', [
                ['fetchViewableDocumentsByCategoryID', 'true'],
                ['member_typeID', exAppContext.membership.member_typeID],
                ['committee_typeID', appContext.user.committee_typeID],
                ['document_categoryID', filter_documentCategory != null ? filter_documentCategory.document_categoryID : '']
            ]);
        } else {
            SetPage(ViewDocuments_PageMap.CATEGORY_SELECTION);
        }
    }, [filter_documentCategory]);

    //watch for fileLabel change, check fileLabel already exist
    // useEffect(() => {
    //     if(attemptUploadDocumentLabel != '' && filter_documentCategory != null) {
    //         databaseInterfaceController.Queue('checkDocumentExist', [
    //             ['checkDocumentExist', 'true'],
    //             ['label', attemptUploadDocumentLabel],
    //             ['document_categoryID', filter_documentCategory.document_categoryID]
    //         ]);
    //     }
    // }, [attemptUploadDocumentLabel, filter_documentCategory]); ---deprecated of unuse

    //watch for database result actions
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchViewableDocumentsByCategoryID':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            let documents = [] as Document[];
                            resObjs.map((resObj: any) => {
                                documents.push(new Document(
                                    resObj['documentID'],
                                    resObj['document_cateogryID'],
                                    resObj['label'],
                                    resObj['description'],
                                    resObj['poster_url'],
                                    resObj['file_url'],
                                    resObj['extra_url'],
                                    resObj['viewable_member_typeIDs'],
                                    resObj['viewable_member_user_types'],
                                    resObj['viewable_committee_typeIDs'],
                                    resObj['creator_userID'],
                                    resObj['datetime_created'],
                                    resObj['datetime_expired'],
                                    resObj['updater_userID'],
                                    resObj['datetime_updated']
                                ));
                            });
                            if (
                                exAppContext.viewMode == App_ViewModeMap.MEMBER
                                || !IsSecretariat()) {
                                documents = RemoveExpiredDocuments(documents);
                            }
                            SetViewableDocuments([...documents]);
                        } else {
                            console.log('fetchViewableDocumentsByCategoryIDErr: ' + res);
                        }
                        break;
                    // case 'checkDocumentExist':
                    //     if(!JSON.stringify(res).includes('_false')) {
                    //         //document exist is true, clear document label, ask user to create another one
                    //         appContext.SetPopupMessage('A same document label is found, please use a different label.');
                    //         SetAttemptUploadDocumentLabel('');
                    //     }
                    //     break; ---deprecated
                    case 'createDocument':
                        if (!JSON.stringify(res).includes('_false')) {
                            uploadDocumentCountRef.current -= 1;
                            if (uploadDocumentCountRef.current > 0 && filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) {
                                const uploadingDocument = newUploadDocuments[newUploadDocuments.length - uploadDocumentCountRef.current];
                                databaseInterfaceController.Queue('createDocument', [
                                    ['createDocument', 'true'],
                                    ['initiatorID', appContext.user.userID],
                                    ['fileName', uploadingDocument.fileName],
                                    ['base64Source', uploadingDocument.source, false],
                                    ['document_categoryID', filter_documentCategory.document_categoryID],
                                    ['label', uploadingDocument.label],
                                    ['description', uploadingDocument.description],
                                    ['base64Poster', uploadingDocument.poster, false],
                                    ['viewable_member_typeIDs', uploadingDocument.viewableMemberTypeIDs.join(',')],
                                    /*['viewable_member_user_types', uploadingDocument.viewableMemberUserTypes.join(',')], --deprecated*/
                                    ['viewable_committee_typeIDs', uploadingDocument.viewableCommitteeTypeIDs.join(',')],
                                    ['datetime_created', uploadingDocument.datetimeCreated != null ? IonDateString(uploadingDocument.datetimeCreated) : IonDateString(new Date())],
                                    ['datetime_expired', uploadingDocument.datetimeExpired != null ? IonDateString(uploadingDocument.datetimeExpired) : ''],
                                    ['creator_userID', appContext.user.userID]
                                ]);

                                appContext.SetWaitScreenMessage('Uploading document ' + (newUploadDocuments.length - uploadDocumentCountRef.current + 1).toString() + '/' + newUploadDocuments.length + '\nplease wait');
                            } else {
                                appContext.SetPopupMessage('Successfully uploaded all documents.');
                                SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION);
                                appContext.SetWaitScreenShouldShow(false);

                                RefetchViewableDocumentsByCategoryID();
                            }
                        } else {
                            console.log('createDocumentErr ' + res);
                            appContext.SetPopupMessage('Fail to upload documents, please try again later.');
                            SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION);
                            appContext.SetWaitScreenShouldShow(false);
                        }
                        break;
                    case 'deleteDocument':
                        if (!JSON.stringify(res).includes('_false')) {
                            RefetchViewableDocumentsByCategoryID();
                            appContext.SetPopupMessage('Successfully deleted a document.');
                        } else {
                            console.log('deleteDocumentErr: ' + res);
                        }
                        break;
                    case 'updateDocumentByID':
                        if (!JSON.stringify(res).includes('_false')) {
                            RefetchViewableDocumentsByCategoryID();
                            appContext.SetPopupMessage('Successfully updated a document.');
                            SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION);
                            SetEditingDocument({} as Document);
                        } else {
                            console.log('updateDocumentErr: ' + res);
                        }
                        break;
                }
            };

            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchViewableDocumentsByCategoryID':
                case 'checkDocumentExist':
                case 'createDocument':
                case 'deleteDocument':
                case 'updateDocumentByID':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnDocumentCategorySelected = (documentCategory: DocumentCategory | null) => {
        if (documentCategory != null) {
            filter_documentCategoryRef.current = documentCategory;
            SetFilter_documentCategory(filter_documentCategoryRef.current);
            SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION);
        } else {
            SetPage(ViewDocuments_PageMap.CATEGORY_SELECTION);
        }
    }
    const OnBackToCategorySelectionClicked = () => {
        filter_documentCategoryRef.current = {} as DocumentCategory;
        SetFilter_documentCategory(filter_documentCategoryRef.current);
        SetPage(ViewDocuments_PageMap.CATEGORY_SELECTION);
    }
    // const OnViewDocumentClicked = async (document: Document) => {
    //     appContext.SetAppStateChangeWatch(false);
    //     Browser.addListener('browserFinished', () => { appContext.SetAppStateChangeWatch(true); });
    //     await Browser.open({ url: document.file_url });
    // } ---deprecated of unuse
    const OnUploadDocumentClicked = () => {
        appContext.SetAppStateChangeWatch(false);
        SetPage(ViewDocuments_PageMap.UPLOAD_DOCUMENTS);

        // appContext.SetWaitScreenMessage('please wait');
        // appContext.SetWaitScreenShouldShow(true);
        // setTimeout(async () => {
        //     // await Camera.pickImages({}).then((res: any) => {
        //     //     //clear up and reset
        //     //     canvasesRef.current = [];
        //     //     imagesRef.current = [];
        //     //     uploadingPhotosCountRef.current = res.photos.length;
        //     //     appContext.SetWaitScreenMessage('importing photos please wait');
        //     //     res.photos.map((photo: any, i: number) => {
        //     //         Resize(photo.webPath ? photo.webPath : '');
        //     //     });
        //     // const _res = res.photos[0];
        //     // Resize(_res.webPath ? _res.webPath : '');
        //     // });
        // }, 500);
    }
    const OnProceedUploadDocumentsClicked = () => {
        if (
            newUploadDocuments.length > 0
        ) {
            if (filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) {
                uploadDocumentCountRef.current = newUploadDocuments.length;
                const uploadingDocument = newUploadDocuments[newUploadDocuments.length - uploadDocumentCountRef.current];

                databaseInterfaceController.Queue('createDocument', [
                    ['createDocument', 'true'],
                    ['initiatorID', appContext.user.userID],
                    ['fileName', uploadingDocument.fileName],
                    ['base64Source', uploadingDocument.source, false],
                    ['document_categoryID', filter_documentCategory.document_categoryID],
                    ['label', uploadingDocument.label],
                    ['description', uploadingDocument.description],
                    ['base64Poster', uploadingDocument.poster, false],
                    ['viewable_member_typeIDs', uploadingDocument.viewableMemberTypeIDs.join(',')],
                    /*['viewable_member_user_types', uploadingDocument.viewableMemberUserTypes.join(',')], --deprecated*/
                    ['viewable_committee_typeIDs', uploadingDocument.viewableCommitteeTypeIDs.join(',')],
                    ['datetime_created', uploadingDocument.datetimeCreated != null ? IonDateString(uploadingDocument.datetimeCreated) : IonDateString(new Date())],
                    ['datetime_expired', uploadingDocument.datetimeExpired != null ? IonDateString(uploadingDocument.datetimeExpired) : ''],
                    ['creator_userID', appContext.user.userID],
                ]);

                appContext.SetWaitScreenMessage('Uploading document ' + (newUploadDocuments.length - uploadDocumentCountRef.current + 1).toString() + '/' + newUploadDocuments.length + '\nplease wait');
                appContext.SetWaitScreenShouldShow(true);
            } else {
                console.log('OnProceedUploadDocumentsClickedErr documentCategoryNotSelected');
            }
        } else {
            appContext.SetPopupMessage('You must select at least 1 document to upload.');
        }
    }
    const OnAddDiscardDocumentClicked = (add: boolean) => {
        if (add) {
            if (Object.keys(editingDocument).length == 0) {
                //is creating new document
                if (
                    Object.keys(attemptUploadDocument).length > 0
                    && attemptUploadDocumentLabel.length > 0
                    && (
                        attemptUploadDocumentShouldExpired == false
                        || attemptUploadDocumentDateTimeExpired != null
                    )
                ) {
                    if (
                        IsAtLeastOneCheckItemSelected(memberTypeListChecks)
                        || IsAtLeastOneCheckItemSelected(memberUserTypeListChecks)
                        || IsAtLeastOneCheckItemSelected(committeeTypeListChecks)
                    ) {
                        const fileNameArr = attemptUploadDocument.fileName.split('.');
                        const preFix = fileNameArr[fileNameArr.length - 1];
                        newUploadDocumentsRef.current.push({
                            fileName: attemptUploadDocumentLabel + '.' + preFix,
                            source: attemptUploadDocument.source,
                            label: attemptUploadDocumentLabel,
                            description: attemptUploadDocumentDescription,
                            poster: attemptUploadDocumentPoster,
                            viewableMemberTypeIDs: GetCheckListResults(memberTypeCheckList, memberTypeListChecks).map((memberTypeLabel: string) => GetMemberTypeIDByLabel(memberTypeLabel)),
                            viewableMemberUserTypes: GetCheckListResults(memberUserTypeCheckList, memberUserTypeListChecks).map((memberUserTypeLabel: string) => GetMemberUserTypeByLabel(memberUserTypeLabel)),
                            viewableCommitteeTypeIDs: GetCheckListResults(committeeTypeCheckList, committeeTypeListChecks).map((committeeTypeLabel: string) => GetCommitteeTypeIDByLabel(committeeTypeLabel)),
                            datetimeCreated: attemptUploadDocumentDateTimeCreated,
                            datetimeExpired: attemptUploadDocumentDateTimeExpired
                        } as DocumentMap);
                        SetNewUploadDocuments([...newUploadDocumentsRef.current]);
                        SetPage(ViewDocuments_PageMap.UPLOAD_DOCUMENTS);
                    } else {
                        appContext.SetPopupMessage('You must select at least one user type who is allowed to view this document.');
                    }
                } else {
                    appContext.SetPopupMessage('You must fill in all fields marked (*)');
                }
            } else {
                //is editing document
                if (
                    attemptUploadDocumentLabel.length > 0
                    && (
                        attemptUploadDocumentShouldExpired == false
                        || attemptUploadDocumentDateTimeExpired != null
                    )
                ) {
                    if (
                        IsAtLeastOneCheckItemSelected(memberTypeListChecks)
                        || IsAtLeastOneCheckItemSelected(memberUserTypeListChecks)
                        || IsAtLeastOneCheckItemSelected(committeeTypeListChecks)
                    ) {
                        //update documents on server
                        databaseInterfaceController.Queue('updateDocumentByID', [
                            ['updateDocumentByID', 'true'],
                            ['initiatorID', appContext.user.userID],
                            ['documentID', editingDocument.documentID],
                            ['label', attemptUploadDocumentLabel],
                            ['description', attemptUploadDocumentDescription],

                            shouldReplacePosterRef.current ?
                                ['base64Poster', attemptUploadDocumentPoster, false]
                                :
                                ['base64Poster', ''],

                            ['viewable_member_typeIDs', GetCheckListResults(memberTypeCheckList, memberTypeListChecks).map((memberTypeLabel: string) => GetMemberTypeIDByLabel(memberTypeLabel)).join(',')],
                            /*['viewable_member_user_types', GetCheckListResults(memberUserTypeCheckList, memberUserTypeListChecks).map((memberUserTypeLabel: string) => GetMemberUserTypeByLabel(memberUserTypeLabel)).join(',')], ---deprecated*/
                            ['viewable_committee_typeIDs', GetCheckListResults(committeeTypeCheckList, committeeTypeListChecks).map((committeeTypeLabel: string) => GetCommitteeTypeIDByLabel(committeeTypeLabel)).join(',')],
                            ['datetime_created', attemptUploadDocumentDateTimeCreated != null ? IonDateString(attemptUploadDocumentDateTimeCreated) : IonDateString(new Date())],
                            ['datetime_expired', attemptUploadDocumentDateTimeExpired != null ? IonDateString(attemptUploadDocumentDateTimeExpired) : '']
                        ]);
                    } else {
                        appContext.SetPopupMessage('You must select at least one user type who is allowed to view this document.');
                    }
                } else {
                    appContext.SetPopupMessage('You must fill in all fields marked (*)');
                }
            }
        } else {
            appContext.SetPopupMessage('Are you sure to discard this setup?');
            appContext.SetPopupButtons(['Yes', 'No']);
            appContext.SetPopupActions([() => {
                if (Object.keys(editingDocument).length == 0)
                    SetPage(ViewDocuments_PageMap.UPLOAD_DOCUMENTS);
                else {
                    SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION);
                    SetEditingDocument({} as Document);
                }
            }, () => { }]);
        }
    }
    const OnRemoveUploadDocumentClicked = (i: number) => {
        newUploadDocumentsRef.current.splice(i, 1);
        SetNewUploadDocuments([...newUploadDocumentsRef.current]);
    }
    const OnSelectDocumentClicked = async () => {
        appContext.SetAppStateChangeWatch(false);
        const files = await FilePicker.pickFiles({ readData: true, types: ['image/png', 'image/jpeg', 'application/pdf', 'text/csv', 'text/plain'], multiple: false })
            .then((res: any) => { return res.files })
            .catch((err: string) => { console.log('FilepickerPickFilesErr: ' + err); return []; });

        let someFilesOversized = false;
        files.map((file: any, i: number) => {
            if (file.size / (1048576) <= nonstate.max_attachment_size) {
                attemptUploadDocumentRef.current = {
                    fileName: file.name,
                    source: 'data:' + file.mimeType + ';base64,' + file.data
                } as DocumentMap;
                SetAttemptUploadDocument(attemptUploadDocumentRef.current);
                const fileNameArr = file.name.split('.');
                const prefix = fileNameArr[fileNameArr.length - 1];
                SetAttemptUploadDocumentLabel(file.name.replace('.' + prefix, ''));
            } else {
                someFilesOversized = true;
            }
        });

        if (someFilesOversized) {
            appContext.SetPopupMessage('Some files are not selected, please make sure the file size is below (' + nonstate.max_attachment_size + 'MB)');
        }
    }
    const OnAttemptToDeleteDocumentClicked = (document: Document) => {
        if (filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) {
            appContext.SetPopupMessage('Are you sure you wanted to delete the selected document ?');
            appContext.SetPopupButtons(['Yes', 'No']);
            appContext.SetPopupActions([() => {
                databaseInterfaceController.Queue('deleteDocument', [
                    ['deleteDocument', 'true'],
                    ['documentID', document.documentID],
                    ['document_categoryID', filter_documentCategory],
                    ['label', document.label],
                    ['updaterID', appContext.user.userID],
                    ['dateNow', IonDateString(new Date())]
                ]);
            }, () => { }]);
        } else {
            console.log('OnAttemptToDeleteDocumentClickedErr filterDocumentCategoryIsNull');
        }
    }
    const OnEditDocumentClicked = (document: Document) => {
        SetEditingDocument(document);
        setTimeout(() => {
            SetPage(ViewDocuments_PageMap.DOCUMENT_SETUP);
        }, 250);
    }
    const OnBrowsePosterClicked = async () => {
        appContext.SetAppStateChangeWatch(false);

        await Camera.pickImages({ limit: 1 }).then((res: any) => {
            const _res = res.photos[0];
            // CropAndResize(_res.webPath ? _res.webPath : ''); ---deprecated to resize
            Resize(_res.webPath ? _res.webPath : '');
        });
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ViewDocuments_PageMap.CATEGORY_SELECTION:
                return RenderCategorySelectionPage();
            case ViewDocuments_PageMap.DOCUMENT_SELECTION:
                return RenderDocumentSelectionPage();
            case ViewDocuments_PageMap.UPLOAD_DOCUMENTS:
                return RenderUploadDocumentsPage();
            case ViewDocuments_PageMap.DOCUMENT_SETUP:
                return RenderBrowseDocumentPage();
        }
    }
    const RenderPageTitle = () => {
        switch (page) {
            default:
            case ViewDocuments_PageMap.CATEGORY_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>DOCUMENT CATEGORY SELECTION</span>
                        {/* <div className='title-option-panel'>
                            <button className='title-option-btn left' onClick={() => OnDocumentCategorySelected(null)}>View All Categories</button>
                            <div className='vr' />
                            <button className='title-option-btn right' onClick={() => {
                                if (shouldFastScrollBottom) {
                                    pageRef.current.scrollTo({ top: pageRef.current.scrollHeight - pageRef.current.clientHeight, behaviour: 'smooth' });
                                } else {
                                    pageRef.current.scrollTo({ top: 0, behaviour: 'smooth' });
                                }
                            }}>
                                {
                                    shouldFastScrollBottom ?
                                        <Fragment>To Bottom <ArrowDropDownIcon /></Fragment>
                                        :
                                        <Fragment>To Top <ArrowDropUpIcon /></Fragment>
                                }
                            </button>
                        </div> */}
                    </div>
                );
            case ViewDocuments_PageMap.DOCUMENT_SELECTION:
                return (
                    <div className='page-title-block'>
                        <span className='title-lbl'>{(filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) ? filter_documentCategory.label.toUpperCase() : 'ALL DOCUMENTS'}</span>
                        {/* <div className='title-option-panel'>
                            <button className='title-option-btn left' onClick={() => OnBackToCategorySelectionClicked()}>Back To Category Selection</button>
                            <div className='vr' />
                            <button className='title-option-btn right' onClick={() => {
                                if (shouldFastScrollBottom) {
                                    pageRef.current.scrollTo({ top: pageRef.current.scrollHeight - pageRef.current.clientHeight, behaviour: 'smooth' });
                                } else {
                                    pageRef.current.scrollTo({ top: 0, behaviour: 'smooth' });
                                }
                            }}>
                                {
                                    shouldFastScrollBottom ?
                                        <Fragment>To Bottom <ArrowDropDownIcon /></Fragment>
                                        :
                                        <Fragment>To Top <ArrowDropUpIcon /></Fragment>
                                }
                            </button>
                        </div> */}
                    </div>
                );
        }
    }
    const RenderCategorySelectionPage = () => {
        return (
            <div className='page category-selection' ref={pageRef}>
                {RenderPageTitle()}
                {
                    exAppContext.documentCategories.map((documentCategory: DocumentCategory, i: number) => {
                        return (
                            <button className='selection-btn' key={'selection-btn-' + i} onClick={() => OnDocumentCategorySelected(documentCategory)}>{documentCategory.label}</button>
                        )
                    })
                }
            </div>
        )
    }
    const RenderDocumentSelectionPage = () => {
        const filteredDocuments = [] as Document[];
        viewableDocuments.map((document: Document) => {
            if (
                filter_searchString != ''
                && (document.label.toLowerCase().includes(filter_searchString.toLowerCase())
                    || document.description.toLowerCase().includes(filter_searchString.toLowerCase())
                    || IonDateString(document.datetime_created).includes(filter_searchString.toLowerCase())
                )
            ) {
                filteredDocuments.push(document);
            } else if (filter_searchString == '') {
                filteredDocuments.push(document);
            }
        });
        const newsletterYears = [] as string[];
        if (filter_documentCategory?.document_categoryID == GetNewsletterDocumentCategory().document_categoryID) {
            //is newsletters
            viewableDocuments.map((document: Document) => {
                let isSorted = false;
                newsletterYears.map((year: string, i: number) => {
                    if (
                        !isSorted
                        && document.datetime_created
                        && document.datetime_created.getFullYear() > parseInt(year)
                    ) {
                        newsletterYears.splice(i, 0, year);
                    } else if (
                        document.datetime_created
                        && document.datetime_created.getFullYear() == parseInt(year)
                    ) {
                        isSorted = true;
                    }
                });

                if (
                    !isSorted
                    && document.datetime_created
                ) {
                    newsletterYears.push(document.datetime_created.getFullYear().toString());
                }
            });
        }

        return (
            <div className="page document-selection" ref={pageRef}>
                {RenderPageTitle()}
                <div className='document-page-search-bar'>
                    <input className='document-page-search-in' value={filter_searchString} onChange={(e: any) => SetFilter_searchString(e.target.value)} placeholder='type to search' onFocus={() => SetFilter_searchString('')} />
                    <SearchIcon />
                </div>
                {
                    filter_documentCategory
                        && filter_documentCategory.document_categoryID != GetNewsletterDocumentCategory().document_categoryID ?
                        filteredDocuments.length > 0 ?
                            filteredDocuments.map((document: Document, i: number) => {
                                return (
                                    RenderDocumentCard(document, i)
                                )
                            })
                            :
                            <span className='no-document-found-lbl'>No documents found<br />Please check again later</span>
                        :
                        newsletterYears.map((newsletterYear: string, i: number) => {
                            return (
                                <Fragment>
                                    {
                                        IsNewslaterYearFiltered(newsletterYear, filteredDocuments) ?
                                            <span className='document-page-row-title'>{newsletterYear}</span>
                                            :
                                            null
                                    }
                                    <div className='document-page-row' key={'document-page-row-' + i}>
                                        {
                                            filteredDocuments.map((document: Document) => {
                                                if (document.datetime_created?.getFullYear().toString() == newsletterYear) {
                                                    return RenderNewsletterCard(document);
                                                } else {
                                                    return null;
                                                }
                                            })
                                        }
                                    </div>
                                </Fragment>
                            )
                        })
                }
                <div className='document-page-option-panel'>
                    {
                        exAppContext.viewMode == App_ViewModeMap.COMMITTEE && IsSecretariat() ?
                            <Fragment>
                                <button className='document-page-option-btn' onClick={() => OnUploadDocumentClicked()}><AddIcon /> Upload Documents</button>
                            </Fragment>
                            :
                            null
                    }
                </div>
                {
                    appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ?
                    <ScrollBar className='page-scrollbar' targetRef={pageRef}/>
                    :
                    null
                }
            </div>
        );
    }
    const RenderNewsletterCard = (newsletter: Document) => {
        return (
            <div className='newsletter-card'>
                <img className='newsletter-card-img' src={newsletter.poster_url} />
                <div className='newsletter-card-bg-ui' onClick={async () => { await Browser.open({ url: newsletter.file_url }) }} />
                <span className='newsletter-card-lbl'>{newsletter.label}</span>
                {
                    exAppContext.viewMode == App_ViewModeMap.COMMITTEE && IsSecretariat() ?
                        <div className='newsletter-card-option-panel'>
                            <button className='newsletter-card-option-btn' onClick={() => OnAttemptToDeleteDocumentClicked(newsletter)}><DeleteIcon /></button>
                            <button className='newsletter-card-option-btn' onClick={() => OnEditDocumentClicked(newsletter)}><EditIcon /></button>
                        </div>
                        :
                        null
                }
            </div>
        )
    }
    const RenderDocumentCard = (document: Document, i: number) => {
        return (
            <div className='document-card' key={'document-card-' + i}>
                <div className='document-card-header'>
                    <span className='document-card-header-lbl ex'>{(i + 1).toString() + '.'}</span>
                    <div className='document-card-date-block'>
                        <span className='document-card-header-lbl'>{IonDateString(document.datetime_created, IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
                        {
                            exAppContext.viewMode == App_ViewModeMap.COMMITTEE && IsSecretariat() ?
                                <button className='document-card-header-btn' onClick={() => OnAttemptToDeleteDocumentClicked(document)}><DeleteIcon /></button>
                                :
                                null
                        }
                    </div>
                </div>
                <div className='document-card-body'>
                    <div className='document-card-row'>
                        {
                            document.poster_url != '' ?
                                <ImagePreviewer className='document-card-img' src={document.poster_url} />
                                :
                                null
                        }
                        <div className='document-card-col'>
                            <span className='document-card-body-title'>{document.label}</span>
                            {
                                document.description.length > 0 ?
                                    <span className='document-card-body-lbl'>{document.description}</span>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
                <div className='document-card-option-panel'>
                    {
                        exAppContext.viewMode == App_ViewModeMap.COMMITTEE && IsSecretariat() ?
                            <button className='document-card-edit-btn' onClick={() => OnEditDocumentClicked(document)}><EditIcon /></button>
                            :
                            null
                    }
                    {
                        document.extra_url.trim().length > 0 ?
                            <button className='document-card-browse-btn' onClick={async () => { await Browser.open({ url: document.extra_url }) }}><TravelExploreIcon /></button>
                            :
                            null
                    }
                    {
                        document.file_url.trim().length > 0 ?
                            <button className='document-card-file-btn' onClick={async () => { await Browser.open({ url: document.file_url }) }}><FileOpenIcon style={{ transform: `rotateY(180deg)` }} /></button>
                            :
                            null
                    }
                </div>
            </div>
        );
    }
    const RenderUploadDocumentsPage = () => {
        return (
            <div className='page upload-documents'>
                <span className='page-title'>Upload Documents</span>
                <span className='page-subtitle'>upload documents for {(filter_documentCategory != null && Object.keys(filter_documentCategory).length > 0) ? filter_documentCategory.label : ''}.</span>
                <div className='page-scroll'>
                    {
                        newUploadDocuments.length > 0 ?
                            newUploadDocuments.map((document: DocumentMap, i: number) => {
                                return (
                                    <div className='page-row' key={'page-row-' + i}>
                                        <span className='page-lbl'>{document.fileName}</span>
                                        <button className='page-btn view-count' onClick={() => SetSelectedVisibilityViewDocument(document)}><VisibilityIcon />{GetViewableUserTypesCount(document)}</button>
                                        <button className='page-btn remove' onClick={() => OnRemoveUploadDocumentClicked(i)}><RemoveIcon /></button>
                                    </div>
                                )
                            })
                            :
                            <span className='not-found-lbl'>No documents selected, click<br />' Add Document ' to add in new documents.</span>
                    }
                </div>
                <div className='page-option-panel'>
                    <button className='page-option-btn' onClick={() => SetPage(ViewDocuments_PageMap.DOCUMENT_SETUP)}><AddIcon />Add Document</button>
                    <button className='page-option-btn' onClick={() => OnProceedUploadDocumentsClicked()}><UploadIcon />Upload</button>
                </div>
                <button className='page-close-btn' onClick={() => SetPage(ViewDocuments_PageMap.DOCUMENT_SELECTION)}><CloseIcon /></button>
            </div>
        );
    }
    const RenderBrowseDocumentPage = () => {
        return (
            <div className='page browse-document'>
                <span className='page-title ex'>Document Setup</span>
                <div className='page-scroll ex' ref={pageScrollRef}>
                    <div className='page-col'>
                        <span className='page-lbl'>Document File * (max {nonstate.max_attachment_size + 'MB'})</span>
                        <span className='page-lbl ex'>{Object.keys(editingDocument).length > 0 ? GetFileNameFromUrl(editingDocument.file_url) : attemptUploadDocument.fileName}</span>
                        <button className='page-btn' onClick={() => OnSelectDocumentClicked()} disabled={Object.keys(editingDocument).length > 0 ? true : false}>Browse Document</button>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>File Label *</span>
                        <input className='page-in' value={attemptUploadDocumentLabel} onChange={(e: any) => SetAttemptUploadDocumentLabel(e.target.value.replace(/[\.]/g, ''))} placeholder='Document Label' />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Description</span>
                        <textarea className='page-in' value={attemptUploadDocumentDescription} onChange={(e: any) => SetAttemptUploadDocumentDescription(e.target.value)} placeholder='Document Description' />
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Poster</span>
                        {
                            attemptUploadDocumentPoster.length > 0 ?
                                <img className='page-img' src={attemptUploadDocumentPoster} />
                                :
                                null
                        }
                        <button className='page-btn' onClick={() => OnBrowsePosterClicked()}>Browse New Poster</button>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Viewable Membership</span>
                        <div className='page-select-checker'>
                            <SelectionChecker placeholder='Select Membership Category' checkList={memberTypeCheckList} checkings={memberTypeListChecks} SetCheckings={SetMemberTypeListChecks} />
                        </div>
                    </div>
                    {/* <div className='page-col'>
                        <span className='page-lbl'>Viewable Account Type</span>
                        <div className='page-select-checker'>
                            <SelectionChecker placeholder='Select Account Type' checkList={memberUserTypeCheckList} checkings={memberUserTypeListChecks} SetCheckings={SetMemberUserTypeListChecks} />
                        </div>
                    </div> ---deprecated */}
                    <div className='page-col'>
                        <span className='page-lbl'>Viewable Committee Type</span>
                        <div className='page-select-checker'>
                            <SelectionChecker placeholder='Select Committee Type' checkList={committeeTypeCheckList} checkings={committeeTypeListChecks} SetCheckings={SetCommitteeTypeListChecks} />
                        </div>
                    </div>
                    <div className='page-col'>
                        <span className='page-lbl'>Display Date</span>
                        <div className='page-datetime-picker'>
                            <DateTimePicker dateTime={attemptUploadDocumentDateTimeCreated} SetDateTime={SetAttemptUploadDocumentDateTimeCreated} mode='date' />
                        </div>
                    </div>
                    <div className='page-col'>
                        <div className='page-checker'>
                            <Checker label='Document should expire' checked={attemptUploadDocumentShouldExpired} SetChecked={(res: boolean) => { SetAttemptUploadDocumentShouldExpired(res); if (res == false) SetAttemptUploadDocumentDateTimeExpired(null); }} OnCheckerClicked={() => {
                                setTimeout(() => {
                                    pageScrollRef.current.scrollTo({ top: pageScrollRef.current.scrollHeight, behavior: 'smooth' });
                                }, 100);
                            }} />
                        </div>
                    </div>
                    {
                        attemptUploadDocumentShouldExpired ?
                            <div className='page-col'>
                                <span className='page-lbl'>Document Expiration Date *</span>
                                <div className='page-datetime-picker'>
                                    <DateTimePicker dateTime={attemptUploadDocumentDateTimeExpired} SetDateTime={SetAttemptUploadDocumentDateTimeExpired} mode='date' placeholder='Select Expiration Date' />
                                </div>
                            </div>
                            :
                            null
                    }
                </div>
                <button className='page-option-btn ex' onClick={() => OnAddDiscardDocumentClicked(true)}>{Object.keys(editingDocument).length == 0 ? 'Add Document' : 'Update Document'}</button>
                <button className='page-close-btn' onClick={() => OnAddDiscardDocumentClicked(false)}><CloseIcon /></button>
            </div>
        )
    }
    const RenderViewDocumentVisibilityListMenu = () => {
        return (
            <div className='menu'>
                <div className='menu-ui-block-mask' />
                <div className='menu-form'>
                    <div className='menu-scroll'>
                        {
                            selectedVisibilityViewDocument.viewableMemberTypeIDs.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Viewable Membership Types</span>
                                    {
                                        selectedVisibilityViewDocument.viewableMemberTypeIDs.map((memberTypeID: string) => {
                                            return (
                                                <span className='menu-txt'>{GetMemberTypeLabelByID(memberTypeID)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                        {
                            selectedVisibilityViewDocument.viewableMemberUserTypes.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Viewable Account Types</span>
                                    {
                                        selectedVisibilityViewDocument.viewableMemberUserTypes.map((userType: string) => {
                                            return (
                                                <span className='menu-txt'>{GetMemberUserTypeLabelByID(userType)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                        {
                            selectedVisibilityViewDocument.viewableCommitteeTypeIDs.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Viewable Committee Types</span>
                                    {
                                        selectedVisibilityViewDocument.viewableCommitteeTypeIDs.map((committeeTypeID: string) => {
                                            return (
                                                <span className='menu-txt'>{GetCommitteeTypeLabelByID(committeeTypeID)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                    </div>
                    <button className='menu-close-btn' onClick={() => SetSelectedVisibilityViewDocument({} as DocumentMap)}><CloseIcon /></button>
                </div>
            </div>
        );
    }

    //reset form functions
    const ResetDocumentSetupForm = () => {
        if (Object.keys(editingDocument).length == 0) {
            SetAttemptUploadDocument({} as DocumentMap);
            SetAttemptUploadDocumentLabel('');
            SetAttemptUploadDocumentDescription('');
            attemptUploadDocumentPosterRef.current = '';
            SetAttemptUploadDocumentPoster(attemptUploadDocumentPosterRef.current);
            SetMemberTypeListChecks([...ResetListChecks(memberTypeListChecks)]);
            SetMemberUserTypeListChecks([...ResetListChecks(memberUserTypeListChecks)]);
            SetCommitteeTypeListChecks([...ResetListChecks(committeeTypeListChecks)]);
            SetAttemptUploadDocumentDateTimeCreated(new Date());
            SetAttemptUploadDocumentShouldExpired(false);
            SetAttemptUploadDocumentDateTimeExpired(null);
        } else {
            // SetAttemptUploadDocument(editingDocument);
            // public fileName: string = '';
            // public source: string = ''; //can be base64String or urlSource
            // public label: string = '';
            // public description: string = '';
            // public viewableMemberTypeIDs: string[] = [];
            // public viewableMemberUserTypes: string[] = [];
            // public viewableCommitteeTypeIDs: string[] = [];
            SetAttemptUploadDocument({} as DocumentMap);
            SetAttemptUploadDocumentLabel(editingDocument.label);
            SetAttemptUploadDocumentDescription(editingDocument.description);

            if (editingDocument.poster_url.length > 0) {
                axios.get(editingDocument.poster_url, { responseType: 'blob' }).then((res: any) => {
                    const reader = new FileReader();

                    reader.onloadend = () => {
                        if (reader.result != null) {
                            attemptUploadDocumentPosterRef.current = reader.result.toString();
                            SetAttemptUploadDocumentPoster(attemptUploadDocumentPosterRef.current);
                        } else {
                            console.log('is here!: ' + JSON.stringify(reader.result));
                        }
                    }

                    reader.readAsDataURL(res.data);
                }).catch((err: any) => {
                    console.log('checkFetchPosterUrlErr: ' + err);
                });
            } else {
                attemptUploadDocumentPosterRef.current = '';
                SetAttemptUploadDocumentPoster(attemptUploadDocumentPosterRef.current);
            }
            SetMemberTypeListChecks([...PopulateListChecks(
                memberTypeCheckList,
                editingDocument.viewable_member_typeIDs.map((id: string) => GetMemberTypeLabelByID(id))
            )]);
            SetMemberUserTypeListChecks([...PopulateListChecks(
                memberUserTypeCheckList,
                editingDocument.viewable_member_user_types.map((id: number) => GetMemberUserTypeLabelByID(id.toString()))
            )]);
            SetCommitteeTypeListChecks([...PopulateListChecks(
                committeeTypeCheckList,
                editingDocument.viewable_committee_typeIDs.map((id: string) => GetCommitteeTypeLabelByID(id))
            )]);
            SetAttemptUploadDocumentDateTimeCreated(editingDocument.datetime_created != null ? editingDocument.datetime_created : new Date());
            if (editingDocument.datetime_expired != null) {
                SetAttemptUploadDocumentShouldExpired(true);
                SetAttemptUploadDocumentDateTimeExpired(editingDocument.datetime_expired);
            }
        }
        shouldReplacePosterRef.current = false;
    }

    //exe functions
    const InitializeSelectionList = () => {
        const _memberTypeCheckList = [] as string[];
        const _memberUserTypeCheckList = [] as string[];
        const _committeeTypeCheckList = [] as string[];

        exAppContext.memberTypes.map((memberType: MemberType) => {
            _memberTypeCheckList.push(ToInitialCap(memberType.label));
        });
        SetMemberTypeCheckList([..._memberTypeCheckList]);

        Object.keys(MemberUser_TypeMap).map((_key: string) => {
            _memberUserTypeCheckList.push(ToInitialCap(_key));
        });
        SetMemberUserTypeCheckList([..._memberUserTypeCheckList]);

        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            _committeeTypeCheckList.push(ToInitialCap(committeeType.label));
        });
        SetCommitteeTypeCheckList([..._committeeTypeCheckList]);
    }
    const GetCheckListResults = (checkList: string[], checkings: boolean[]) => {
        let res = [] as string[];
        checkings.map((check: Boolean, i: number) => {
            if (check)
                res.push(checkList[i]);
        });
        return res;
    }
    const GetMemberTypeIDByLabel = (label: string) => {
        let res = '';
        exAppContext.memberTypes.map((type: MemberType) => {
            if (label.toLowerCase() == type.label.toLowerCase())
                res = type.member_typeID;
        });
        return res;
    }
    const GetMemberTypeLabelByID = (id: string) => {
        let res = '';
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (memberType.member_typeID == id)
                res = ToInitialCap(memberType.label);
        });
        return res;
    }
    const GetMemberUserTypeByLabel = (label: string) => {
        if (MemberUser_TypeMap[label.toUpperCase() as keyof typeof MemberUser_TypeMap] != undefined) {
            return MemberUser_TypeMap[label.toUpperCase() as keyof typeof MemberUser_TypeMap];
        } else {
            return '';
        }
    }
    const GetMemberUserTypeLabelByID = (id: string) => {
        let res = '';
        Object.keys(MemberUser_TypeMap).map((key: string) => {
            if (MemberUser_TypeMap[key as keyof typeof MemberUser_TypeMap].toString() == id)
                res = ToInitialCap(key);
        });
        return res;
    }
    const GetCommitteeTypeIDByLabel = (label: string) => {
        let res = '';
        exAppContext.committeeTypes.map((type: CommitteeType) => {
            if (label.toLowerCase() == type.label.toLowerCase())
                res = type.committee_typeID;
        });
        return res;
    }
    const GetCommitteeTypeLabelByID = (id: string) => {
        let res = '';
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.committee_typeID == id)
                res = ToInitialCap(committeeType.label);
        });
        return res;
    }
    const GetViewableUserTypesCount = (document: DocumentMap) => {
        let count = 0;
        count += document.viewableMemberTypeIDs.length;
        count += document.viewableMemberUserTypes.length;
        count += document.viewableCommitteeTypeIDs.length;
        return count;
    }
    const ResetListChecks = (checkings: boolean[]) => {
        let res = [] as boolean[];
        checkings.map((check: boolean) => {
            res.push(false);
        });
        return res;
    }
    const PopulateListChecks = (checkList: string[], selected: string[]) => {
        const res = [] as boolean[];
        checkList.map((list: string) => {
            if (selected.join(',').includes(list)) {
                res.push(true);
            } else {
                res.push(false);
            }
        });
        return res;
    }
    const GetFileNameFromUrl = (fileUrl: string) => {
        const fileUrlArr = fileUrl.split('/');
        return fileUrlArr[fileUrlArr.length - 1];
    }
    const RemoveExpiredDocuments = (documents: Document[]) => {
        const res = [] as Document[];
        const dateNow = new Date();
        documents.map((document: Document) => {
            if (
                document.datetime_expired == null
                || document.datetime_expired >= dateNow
            )
                res.push(document);
        });
        return res;
    }
    const GetNewsletterDocumentCategory = () => {
        let res = {} as DocumentCategory;
        exAppContext.documentCategories.map((category: DocumentCategory) => {
            if (category.is_newsletter)
                res = category;
        });
        return res;
    };
    const Resize = (imgUrl: string) => {
        canvasRef.current = document.createElement('canvas');
        const context = canvasRef.current.getContext('2d');

        //process image
        if (imgUrl != '') {
            imageRef.current.src = imgUrl;
            imageRef.current.onload = () => {
                //get image profile
                let [orientation, img_width, img_height] = GetImageProfile(imageRef.current);
                const w_h_ratio = img_width / img_height;
                const shouldDrawTillXPos = (orientation == 'portrait' ? nonstate.controlledImgSize : w_h_ratio * nonstate.controlledImgSize);
                const shouldDrawTillYPos = (orientation == 'landscape' ? nonstate.controlledImgSize : nonstate.controlledImgSize / w_h_ratio);

                if (canvasRef.current != undefined) {
                    canvasRef.current.width = shouldDrawTillXPos;
                    canvasRef.current.height = shouldDrawTillYPos;
                }

                if (context) {
                    context.drawImage(
                        imageRef.current,
                        // orientation == 'portrait' ? 0 : offset, //grab ori image pos X
                        // orientation == 'landscape' ? 0 : offset,//grab ori image pos Y
                        0, 0,
                        img_width, img_height,
                        0, 0, //start draw from canvas pos 
                        shouldDrawTillXPos, shouldDrawTillYPos //draw till canvas dimension
                    );
                    if (canvasRef.current) {
                        const imgBase64String = canvasRef.current.toDataURL();
                        attemptUploadDocumentPosterRef.current = imgBase64String;
                        SetAttemptUploadDocumentPoster(attemptUploadDocumentPosterRef.current);

                        //toggle should replace poster to update poster file on the server
                        shouldReplacePosterRef.current = true;
                    }
                }
            }
        }
    }
    const GetImageProfile = (image: HTMLImageElement): [string, number, number] => {

        let orientation: string = '';
        let img_width: number = 0;
        let img_height: number = 0;
        let grabSize: number = 0;
        let grabOffset: number = 0;

        if (image.height >= image.width) {
            //is a portrait or square
            orientation = 'portrait';
            grabSize = image.width;
            grabOffset = (image.height - image.width) / 2;
        } else {
            //is a landscape
            orientation = 'landscape';
            grabSize = image.height;
            grabOffset = (image.width - image.height) / 2;
        }
        img_width = image.width; img_height = image.height;

        return [orientation, img_width, img_height];
    }
    const RefetchViewableDocumentsByCategoryID = () => {
        if(filter_documentCategoryRef.current) {
            databaseInterfaceController.Queue('fetchViewableDocumentsByCategoryID', [
                        ['fetchViewableDocumentsByCategoryID', 'true'],
                        ['member_typeID', exAppContext.membership.member_typeID],
                        ['committee_typeID', appContext.user.committee_typeID],
                        ['document_categoryID', filter_documentCategoryRef.current.document_categoryID]
                    ]);
        }
    }

    //check functions
    const IsSecretariat = () => {
        let res = false;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.label.toLowerCase() == 'secretariat' && committeeType.committee_typeID == appContext.user.committee_typeID)
                res = true;
        });
        return res;
    }
    const IsAtLeastOneCheckItemSelected = (checkings: boolean[]) => {
        let res = false;
        checkings.map((check: boolean) => {
            if (check)
                res = true;
        });
        return res;
    }
    const IsNewslaterYearFiltered = (newsletterYear: string, newsletter: Document[]) => {
        let res = false;
        newsletter.map((newsletter: Document) => {
            if (newsletter.datetime_created?.getFullYear().toString() == newsletterYear)
                res = true;
        });
        return res;
    }
    //conversion functions
    const ToInitialCap = (value: string) => {
        return value.substring(0, 1).toUpperCase() + value.substring(1, value.length).toLowerCase();
    }

    return (
        <div className={'ViewDocuments ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')} ref={viewDocumentsRef}>
            {
                RenderPage()
            }
            {
                Object.keys(selectedVisibilityViewDocument).length > 0 ?
                    RenderViewDocumentVisibilityListMenu()
                    :
                    null
            }
            <SwipeOverscrollHandler targetRef={viewDocumentsRef} direction='top-to-bottom' action={() => { RefetchViewableDocumentsByCategoryID() }} />
        </div>
    )
}
export default ViewDocuments;